<template>
  <div id="app" v-bind:class="{ exclusive: $route.name === 'membership' || isExclusive }">
    <AboutUs v-if="aboutUsMobileRoute"/>
    <BulkOrderMobilePage v-else-if="bulkOrderMobilePage"/>
    <ContactUsMobile :hideMyAccountLink="true" v-else-if="contactUsMobile"/>
    <PrivacyPolicyMobile :contactUs="'/contact-us-mobile'" :renderContactUsMobile="renderContactUsMobile"  v-else-if="privacyPolicyMobile"/>
    <TermsNconditionsMobile v-else-if="termsNconditionMobile"/>
    <UltimateTee v-else-if="theUlimateTeeRoute" />
    <CovidReliefFundMobile v-else-if="covidReliefFundMobile"/>
    <PauseForPawsMobile v-else-if="pauseForPawsMobile"/>
    <Maintenance v-else-if="maintenance" />
    <AuthMobile v-else-if="authMobile" />
    <CareersMobile v-else-if="careersMobile"/>
    <div v-else>
      <div>
        <exclusive-nav-bar v-if="isExclusive" :isExclusive="isExclusive"/>
        <app-nav-layout v-if="isDesktop"></app-nav-layout>
        <App-nav-mobile v-else-if="!isDesktop"></App-nav-mobile>
      </div>
      <GenderDOBModal v-model="genderDOBModal" @closeModal='closeModal' />
      <LogoutModal  :isVisible="showLogoutModal"  title="Confirm Logout"  @update:isVisible="updateModalVisibility"  @confirm="confirmLogout" >
            <div class="logoutContent">
              <img src='https://prod-img.thesouledstore.com/static/goodbye-image.jpg' alt="Sad Emoji" class="emoji-img">
                <p class="logout-message">Are you sure you want to logout?</p>
            </div>
      </LogoutModal>
      <div :class="{'bg-lgrey': isSupimaLanding || isWinterWearLanding, 'activewear-grey': isActiveWearLanding}">
        <transition name="fade">
          <div :class="['tss-body-wrapper',{'minHeight': isHomeRoute},{'pdpMinHeight': isPdpRoute}]">
            <router-view class="viewContainer"></router-view>
          </div>
        </transition>
      </div>
      <app-footer></app-footer>
      <overlay/>
      <WelcomeOfferModal v-if="isWelcomeOfferPopup && !bannerPlaceHolderForGoForAppOnlySale" :toggleWelcomeOfferPopup="toggleWelcomeOfferPopup" :msgArr="bannerPlaceHolderForWelcomeOffer"/>
      <BirthdayDiscountModal v-if="isBdayDiscountPopup && !bannerPlaceHolderForGoForAppOnlySale" :toggleBdayDiscountPopup="toggleBdayDiscountPopup" :msgArr="bannerPlaceHolderForBirthdayDiscount"/>
      <TSSBirthdayModal v-if="isTssBdayPopup  && bannerPlaceHolderForTSSBirthday && bannerPlaceHolderForTSSBirthday.status" :toggleTssBdayPopup="toggleTssBdayPopup" :msgArr="bannerPlaceHolderForTSSBirthday"/>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import './assets/css/bootstrap.css'
  import 'vuejs-dialog/dist/vuejs-dialog.min.css'
  import './assets/css/style.css'
  import '../static/js/bootstrap.min.js'
  import {mapGetters, mapState} from 'vuex'
  import {TIMER} from './assets/js/stickyPopup.js'
  import {appMixins} from './assets/js/appMixins'
  import '../static/js/common.js'
  import '../static/js/custome.js'
  import { uuid } from 'vue-uuid'
  import debounce from 'lodash/debounce'
  import { loadGTM } from '../static/js/loadGTM.js'
  import {loadVinsenz} from '../static/js/loadVinsenz.js'
  import IDB from './utils/indexedDb'

  export default {
    name: 'app',
    mixins: [appMixins],
    components: {
      AppNavLayout: () => import(/* webpackPrefetch: true */ './AppNavLayout.vue'),
      AppNavMobile: () => import(/* webpackPrefetch: true */ './AppNavMobile.vue'),
      AppFooter: () => import(/* webpackPrefetch: true */ './AppFooter.vue'),
      Overlay: () => import(/* webpackPrefetch: true */ './components/common/overlay.vue'),
      ExclusiveNavBar: () => import(/* webpackPrefetch: true */ './components/common/ExclusiveNavBar.vue'),
      ExclusiveSavingInfo: () => import(/* webpackPrefetch: true */ './components/common/ExclusiveSavingInfo.vue'),
      offerPopup: () => import(/* webpackPrefetch: true */ './components/common/offerPopup.vue'),
      AboutUs: () => import(/* webpackPrefetch: true */ './components/about'),
      BulkOrderMobilePage: () => import(/* webpackPrefetch: true */ './components/bulkcustomerorder'),
      ContactUsMobile: () => import(/* webpackPrefetch: true */ './components/contact'),
      UltimateTee: () => import(/* webpackPrefetch: true */ './components/ultimateTee'),
      PrivacyPolicyMobile: () => import(/* webpackPrefetch: true */ './components/privacyPolicy'),
      TermsNconditionsMobile: () => import(/* webpackPrefetch: true */ './components/termsConditions'),
      GenderDOBModal: () => import(/* webpackPrefetch: true */ './components/common/GenderDOBModal'),
      CovidReliefFundMobile: () => import(/* webpackPrefetch: true */ './components/feedTheSoul'),
      PauseForPawsMobile: () => import(/* webpackPrefetch: true */ './components/PauseForPaws/pauseForPaws'),
      Maintenance: () => import(/* webpackPrefetch: true */ './components/Maintenance'),
      WelcomeOfferModal: () => import(/* webpackPrefetch: true */ './components/common/WelcomeOfferModal.vue'),
      BirthdayDiscountModal: () => import(/* webpackPrefetch: true */ './components/common/BirthdayDiscountModal.vue'),
      TSSBirthdayModal: () => import(/* webpackPrefetch: true */ './components/common/TSSBirthdayModal.vue'),
      AuthMobile: () => import('@/components/mobile/AuthMobile'),
      CareersMobile: () => import(/* webpackPrefetch: true */ './components/careers'),
      LogoutModal: () => import('@/components/common/LogoutModal')
    },
    data () {
      return {
        previousItemIds: [],
        previousWishlistIds: [],
        previousItemLength: 0,
        intervalId: null,
        clarityCalled: false,
        timer1: '',
        timer2: '',
        cTimer: TIMER,
        listingHeader: '',
        cartVisited: false,
        aboutUsMobileRoute: false,
        bulkOrderMobilePage: false,
        contactUsMobile: false,
        privacyPolicyMobile: false,
        termsNconditionMobile: false,
        theUlimateTeeRoute: false,
        showGender: false,
        showBirthDate: false,
        covidReliefFundMobile: false,
        pauseForPawsMobile: false,
        maintenance: false,
        isWelcomeOfferPopup: false,
        welcomeOfferTimer: null,
        isBdayDiscountPopup: false,
        isTssBdayPopup: false,
        bdayDiscountTimer: null,
        authMobile: false,
        careersMobile: false,
        newDesignMweb: false,
        updatedVersion: 0,
        isIpCalled: false
      }
    },
    created: function () {
      IDB.set('homeListingCache', null).then(() => {})
      this.$store.dispatch('COUNTRIES')
      this.$store.dispatch('loadCountryFromLocalStorage')
      // this.$store.dispatch('GET_IP_ADDRESS')
      // Currently Disable for Improvement of global tss
      this.$store.dispatch('GET_SIDENAV_DATA')
      if (this.$route.path !== '/maintenance') {
        Promise.all([
          this.$store.dispatch('CHECK_AUTH'),
          this.$store.dispatch('GET_BANNERS_DATA_FROM_MOBILE_CMS'),
          // this.$store.dispatch('GET_NAVMENU_DATA'),
          this.$store.dispatch('GET_UNBXD_ELASTIC_SEARCH_TYPE')
        ])
        if (!this.authStatus) {
          const searchHistory = Vue.ls.get('searchHistory')
          this.$store.dispatch('SET_SEARCH_HISTORY_LIST', {
            user_id: 0,
            searchHistory: searchHistory && searchHistory.length ? searchHistory : [{name: 'recent searches', list: []}]
          })
        }
        let _this = this
        setTimeout(function () {
          if (_this.authStatus) {
            _this.$store.dispatch('USER').then((response) => {
              let finalObj = {...response}
              !(finalObj.gender && finalObj.gender.length) ? delete finalObj.gender : ''
              finalObj.telephone === '' ? finalObj.telephone = '0000000000' : ''
              _this.$store.commit('GTAG_EVENT', {eventName: 'response.profile.payload',
                payload: {
                  profile_response: finalObj,
                  exclusive_user: this.get_exclusive_user
                }}
              )
              _this.$store.commit('MOENGAGE_SET_USER', response)
            })
            return false
          }
        }, 500)

        // Setting session id
        if (!Vue.ls.get('session_id')) {
          Vue.ls.set('session_id', uuid.v1())
        }
      }
      this.getNewPdp()
      let currencyData = {
        currencyType: 'Rs.',
        currencySymbol: '₹'
      }
      this.$store.commit('SET_CURRENCY', currencyData)
      this.$store.dispatch('SESSION_COUNT', true)
    },
    mounted: function () {
      window.addEventListener('scroll', this.getScroll)
      const email = this.user.email
      const phone = this.user.telephone
      window.snaptr('track', 'APP_OPEN', {
        user_email: email,
        user_phone_number: phone
      })
      this.$store.dispatch('COUNTRY_DETAIL')
      window.addEventListener('offline', this.handleOffline)
      window.addEventListener('online', this.handleOnline)
      if (!navigator.onLine) {
        this.showOfflineToast()
      }
      this.$store.commit('SET_GLOBAL_SETTING_KEYS', ['footer_homebrand_text', 'SHOW_WEB_MENU_WOMEN', 'SHOW_WEB_MENU_MEN', 'SHOW_WEB_MENU_KIDS', 'SHOW_PARTIAL_CART'])
      this.loadScript()
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => {
          this.loadThirdPartyScript('//rum-static.pingdom.net/pa-617faeb39034fb0011000234.js')
        })
      } else {
        // Fallback for browsers without requestIdleCallback
        setTimeout(() => {
          this.loadThirdPartyScript('//rum-static.pingdom.net/pa-617faeb39034fb0011000234.js')
        }, 5000)
      }
      if (!this.authStatus && this.$route.path === '/' && this.isComboActive) {
        this.$store.commit('GTAG_EVENT', {eventName: 'landing_homepage', payload: {email: this.user ? this.user.email : 'NA', gender: this.user.gender ? this.user.gender : 'NA'}})
      }
      switch (this.$route.path) {
      // routes to be rendered on mobile app via web-view without header and footer and redirects
        case '/about-us-mobile':
          this.aboutUsMobileRoute = true
          break
        case '/bulk-and-custom-orders-mobile':
          this.bulkOrderMobilePage = true
          break
        case '/contact-us-mobile':
          this.contactUsMobile = true
          break
        case '/privacy-policy-mobile':
          this.privacyPolicyMobile = true
          break
        case '/terms-and-conditions-mobile':
          this.termsNconditionMobile = true
          break
        case '/the-ultimate-tee-mobile':
          this.theUlimateTeeRoute = true
          break
        case '/covidrelieffund-mobile':
          this.covidReliefFundMobile = true
          break
        case '/pause-for-paws-mobile':
          this.pauseForPawsMobile = true
          break
        case '/maintenance':
          this.maintenance = true
          break
        case '/login':
          !this.isDesktop ? this.authMobile = true : ''
          break
        case '/register':
          !this.isDesktop ? this.authMobile = true : ''
          break
        case '/careers-mobile':
          this.careersMobile = true
          break
        default:
          break
      }
      const promises = [
        this.$store.dispatch('loadCountryFromLocalStorage')
      ]
      if (this.authStatus) {
        this.$store.dispatch('CART_WISHLIST_COUNT')
      }
      if (this.$route.path !== '/') {
        // this.cartCleared ? promises.push(this.$store.dispatch('CART_DATA')) : ''
        // this.$store.dispatch('CART_WISHLIST_COUNT')
        // promises.push(this.$store.dispatch('WISHLIST_DATA'))
        if (this.authStatus && !this.isDesktop && this.notMobileOrderPage) {
          promises.push(this.$store.dispatch('ORDERS'))
        }
      }
      Promise.all(promises)
      // ContactUsMobile
      let currentTimerVal = Vue.ls.get('tss_offer_timer')
      if (currentTimerVal) {
        if (parseInt(currentTimerVal) > 0 && parseInt(currentTimerVal) < this.cTimer.OFFER_COUNTDOWN_TIMER) {
          this.$store.commit('MODIFY_OFFER_APPEAR_TIMER', 0)
          this.$store.commit('MODIFY_OFFER_TIMER', parseInt(currentTimerVal))
        }
      }
      // Inserting goaffpro script
      const script = document.createElement('script')
      script.setAttribute('type', 'text/javascript')
      script.setAttribute('src', process.env.GOAFFPRO_SCRIPT_SRC_URL)
      document.head.appendChild(script)
      this.showWelcomeOfferPopup()
      this.showBirthdayDiscountPopup()
      setTimeout(() => {
        this.showTssBirthdayPopup()
      }, 1000)
      this.$store.commit('SET_POS_LOGIN_USER', Vue.ls.get('pos_login'))
      this.$store.commit('SET_COD_CHECKOUT_LOGIN_USER', Vue.ls.get('cod_checkout_login'))
      this.$store.commit('MODIFY_OFFER_APPEAR_TIMER', 0)
    },
    updated: function () {
      const currentHostname = window.location.hostname
      const currentPath = window.location.pathname
      const currentPort = window.location.port
      const isLocalEnvironment = currentHostname.includes('localhost')
      if (!['/thank-you', '/delivery-address', '/codcheckout', '/add-address'].includes(currentPath) && this.isCodCheckoutLogin && !currentPath.startsWith('/edit-address/')) {
        const mainDomain = currentHostname.replace('checkout.', '')
        this.$store.commit('SET_COD_CHECKOUT_LOGIN_USER', false)
        Vue.ls.remove('cod_checkout_login')
        if (isLocalEnvironment) {
          window.location.href = `http://${mainDomain}:${currentPort}`
        } else {
          window.location.href = `https://${mainDomain}`
        }
      }
    },
    watch: {
      'getViewContent.itemIds' (newIds) {
        const newUniqueIds = newIds.filter(id => !this.previousItemIds.includes(id))
        if (newUniqueIds.length > 0) {
          window.snaptr('track', 'VIEW_CONTENT', {
            price: this.getViewContent.price,
            currency: 'INR',
            item_ids: this.getViewContent.itemIds,
            item_category: this.getViewContent.categories,
            uuid_c1: this.user.userid,
            user_email: this.user.email,
            user_phone_number: this.user.telephone
          })
          this.previousItemIds = [...newIds]
        }
      },
      getGlobalSettingKeys: {
        handler: function (newVal) {
          const countryId = this.$store.state.selectedCountryAddress.countryId
          const configKeys = newVal
          this.$store.dispatch('GLOBAL_GET_BANNERS_DATA', { countryId, configKeys })
        },
        deep: true
      },
      showLogoutModal (newValue) {
        if (newValue) {
          document.body.classList.add('freeze_screen')
        } else {
          document.body.classList.remove('freeze_screen')
        }
      },
      enableVincenzeSearch (newval) {
        if (newval) {
          loadVinsenz(newval.tag_text, newval.description)
        }
      },
      isNavBarActive (newVal) {
        if (newVal) {
          this.$store.dispatch('GET_NAVMENU_DATA')
        }
      },
      routeAndIsCombo: {
        handler: function (val) {
          const {routePath, isComboActive, user} = val
          if (isComboActive !== '' && this.$route.matched && this.$route.matched.length) {
            if (routePath === '/men' && isComboActive) {
              this.$store.commit('WEBCATEGORY', 'men')
              Vue.ls.set('tss_landingCategory', 'men')
              Vue.ls.set('listCache_header', '')
            } else if (routePath === '/women' && isComboActive) {
              this.$store.commit('WEBCATEGORY', 'women')
              Vue.ls.set('tss_landingCategory', 'women')
              Vue.ls.set('listCache_header', '')
            } else if (routePath === '/kids' && isComboActive) {
              this.$store.commit('WEBCATEGORY', 'kids')
              Vue.ls.set('tss_landingCategory', 'kids')
              Vue.ls.set('listCache_header', '')
            } else if (routePath === '/sneakers' && isComboActive) {
              this.$store.commit('WEBCATEGORY', 'sneakers')
              Vue.ls.set('tss_landingCategory', 'sneakers')
              Vue.ls.set('listCache_header', '')
            } else if (Vue.ls.get('tss_landingCategory') && this.webcategory && routePath === '/' && isComboActive) {
              this.$store.commit('GTAG_EVENT', {eventName: 'landing_menwomen', payload: {gender: gender}})
              const gender = Vue.ls.get('tss_landingCategory')
              this.$router.push(`/${gender}`)
              // const activeNav = Vue.ls.get('active_webnavcategory')
              // this.$store.commit('SET_ACTIVE_WEB_CATEGORY', activeNav.name.toLowerCase())
              // this.$router.push(`${activeNav.url}`)
            } else if (Vue.ls.get('tss_landingCategory') && !this.webcategory) {
              const gender = Vue.ls.get('tss_landingCategory')
              this.$store.commit('WEBCATEGORY', gender)
              Vue.ls.set('listCache_header', '')
              if (routePath === '/' && isComboActive) {
                this.$store.commit('GTAG_EVENT', {eventName: 'landing_menwomen', payload: {gender: gender}})
                this.$router.push(`/${gender}`)
              }
            } else if (routePath !== '/men' && routePath !== '/women' && routePath !== '/kids' && routePath !== '/sneakers' && !Vue.ls.get('tss_landingCategory') && !this.webcategory) {
              if (this.isComboActive) {
                if (this.user && this.user.gender) {
                  const landingCategory = user.gender === 'M' ? 'men' : 'women'
                  this.$store.commit('WEBCATEGORY', landingCategory)
                  Vue.ls.set('tss_landingCategory', landingCategory)
                  Vue.ls.set('listCache_header', '')
                  this.$store.commit('GTAG_EVENT', {eventName: 'landing_menwomen', payload: {gender: landingCategory}})
                  if (routePath === '/') {
                    this.$router.push(`/${landingCategory}`)
                  }
                } else if (routePath !== '/' && (this.authStatus && this.user && Object.keys(this.user).length || !this.authStatus)) {
                  Vue.ls.set('tss_landingCategory', 'men')
                  this.$store.commit('WEBCATEGORY', 'men')
                  Vue.ls.set('listCache_header', '')
                } else {
                  this.$store.commit('GTAG_EVENT', {eventName: 'landing_homepage', payload: {email: user.email ? user.email : 'NA', gender: user.gender ? user.gender : 'NA'}})
                }
              } else {
                this.$store.commit('WEBCATEGORY', 'men')
                Vue.ls.set('listCache_header', '')
              }
            }
          }
        },
        deep: true
      },
      // adding class to body when on star-war artist
      $route (to, from) {
        const email = this.user.email
        const phone = this.user.telephone
        window.snaptr('track', 'PAGE_VIEW', {
          user_email: email,
          user_phone_number: phone
        })
        if (from.path === '/' && to.path !== '/') {
          Promise.all([
            // this.cartCleared ? this.$store.dispatch('CART_DATA') : '',
            // this.$store.dispatch('CART_WISHLIST_COUNT'),
            // this.$store.dispatch('WISHLIST_DATA'),
            this.authStatus && !this.isDesktop && this.notMobileOrderPage ? this.$store.dispatch('ORDERS') : ''
          ])
        }
        let routeInfo = Vue.ls.get('listing-scroll-pos')
        if (routeInfo) {
          if (routeInfo.urlFrom === to.path && routeInfo.urlTo === from.path) {
            routeInfo.performScroll = true
            Vue.ls.set('listing-scroll-pos', routeInfo)
          } else {
            routeInfo.performScroll = false
            Vue.ls.set('listing-scroll-pos', routeInfo)
          }
        }
        if (to.path !== '/artists/starwars-official-merchandise') {
          document.body.classList.remove('dark-mode', 'light-mode')
        }
        if (this.aboutUsMobileRoute) {
          this.aboutUsMobileRoute = false
        }
        if (this.bulkOrderMobilePage) {
          this.bulkOrderMobilePage = false
        }
        if (this.contactUsMobile) {
          this.contactUsMobile = false
        }
        if (this.theUlimateTeeRoute) {
          this.theUlimateTeeRoute = false
        }
        if (this.covidReliefFundMobile) {
          this.covidReliefFundMobile = false
        }
        if (this.pauseForPawsMobile) {
          this.pauseForPawsMobile = false
        }
        if (this.authMobile) {
          this.authMobile = false
        }
        if (this.careersMobile) {
          this.careersMobile = false
        }
        switch (this.$route.path) {
        // routes to be rendered on mobile app via web-view without header and footer and redirects
          case '/about-us-mobile':
            this.aboutUsMobileRoute = true
            break
          case '/bulk-and-custom-orders-mobile':
            this.bulkOrderMobilePage = true
            break
          case '/contact-us-mobile':
            this.contactUsMobile = true
            break
          case '/privacy-policy-mobile':
            this.privacyPolicyMobile = true
            break
          case '/terms-and-conditions-mobile':
            this.termsNconditionMobile = true
            break
          case '/the-ultimate-tee-mobile':
            this.theUlimateTeeRoute = true
            break
          case '/covidrelieffund-mobile':
            this.covidReliefFundMobile = true
            break
          case '/pause-for-paws-mobile':
            this.pauseForPawsMobile = true
            break
          case '/login':
            !this.isDesktop ? this.authMobile = true : ''
            break
          case '/register':
            !this.isDesktop ? this.authMobile = true : ''
            break
          case '/careers-mobile':
            this.careersMobile = true
            break
          default:
            break
        }
        if (from.path === '/login' || from.path === '/register') {
          if (to.path === '/metaverse') {
            let token = Vue.ls.get('tss_token')
            let email = Vue.ls.get('email')
            this.$store.dispatch('TATVIC_EVENT', {eventName: 'METAVERSE_REDIRECTED'})
            token ? window.location.href = `https://luru.gmetri.com/thesouledstore?token_tss=${token}&user_email=${email}` : ''
          }
          this.showWelcomeOfferPopup()
          this.showBirthdayDiscountPopup()
          this.showTssBirthdayPopup()
        }
      },
      user () {
        this.setRumUserContext()
        if (this.authStatus && this.user && this.user.user_id) {
          this.$store.dispatch('CHECK_EXCLUSIVE_DETAILS', this.user.user_id)
          this.showWelcomeOfferPopup()
          this.showBirthdayDiscountPopup()
          this.showTssBirthdayPopup()
          this.$store.commit('MOENGAGE_CUSTOM_ATTRIBUTES', {attName: 'Active_TSS_Points', payload: Math.floor(this.user.tss_points)})
          this.$store.commit('MOENGAGE_CUSTOM_ATTRIBUTES', {attName: 'Active_TSS_Money', payload: Math.floor(this.user.tss_money)})
          this.$store.commit('MOENGAGE_CUSTOM_ATTRIBUTES', {attName: 'No_Of_Conversions', payload: this.user.successful_orders})
          this.$store.commit('MOENGAGE_CUSTOM_ATTRIBUTES', {attName: 'LTV', payload: Math.floor(this.user.total_spending)})
          this.$store.commit('MOENGAGE_CUSTOM_ATTRIBUTES', {attName: 'TSS_Money_ExpiringValue', payload: Math.floor(this.user.next_Tss_Money_To_Expire)})
          this.$store.commit('MOENGAGE_CUSTOM_ATTRIBUTES', {attName: 'TSS_Points_ExpiringValue', payload: Math.floor(this.user.next_Tss_Point_To_Expire)})
        }
      },
      authStatus () {
        if (!this.authStatus) {
          this.$store.dispatch('RESET_EXCLUSIVE_DETAILS')
        } else {
          const searchHistory = Vue.ls.get('searchHistory')
          this.$store.dispatch('SET_SEARCH_HISTORY_LIST', {
            user_id: this.user && this.user.user_id,
            searchHistory: searchHistory && searchHistory.length ? searchHistory : [{name: 'recent searches', list: []}]
          })
          this.$nextTick(() => {
            this.customerUpdateHandler()
          })
        }
        this.bdayDiscountTimer = null
        this.welcomeOfferTimer = null
      },
      bannerPlcaeHolderData (bannerplacArr) {
        if (bannerplacArr && bannerplacArr.length) {
          // banner placeholder for combos
          if (this.bannerPlaceHolderForCombos) {
            this.$store.commit('SET_COMBO_ACTIVE', true)
          } else {
            this.$store.commit('SET_COMBO_ACTIVE', false)
          }

          // banner placeholder for exclusive popup
          if (this.bannerPlaceHolderForExcPopupOnPdp) {
            this.$store.commit('ENABLE_EXCLUSIVE_POPUP_ON_PDP', true)
          } else {
            this.$store.commit('ENABLE_EXCLUSIVE_POPUP_ON_PDP', false)
          }

          // banner placeholder for exclusive savings txt
          if (this.bannerPlaceHolderForExcSavingTxt) {
            this.$store.commit('SET_MEMBER_SAVINGS_TXT', this.bannerPlaceHolderForExcSavingTxt)
          }

          // banner placeholder for non exclusive savings txt
          if (this.bannerPlaceHolderForNonExcSavingTxt) {
            this.$store.commit('SET_NON_MEMBER_SAVINGS_TXT', this.bannerPlaceHolderForNonExcSavingTxt)
          }

          // banner placeholder for wishlist
          if (this.bannerPlaceHolderForWishlist) {
            this.$store.commit('DISABLE_WISHLIST', true)
          }

          // banner placeholder for Email login
          if (this.bannerPlaceHolderForEmailLogin) {
            this.$store.commit('DISABLE_EMAIL_LOGIN', true)
          }

          if (this.bannerPlaceHolderForClarity && !this.clarityCalled) {
            this.clarityCalled = true
            if ('requestIdleCallback' in window) {
              requestIdleCallback(() => {
                this.initMsClarityScript()
              })
            } else {
              setTimeout(() => {
                this.initMsClarityScript()
              }, 5000)
            }
          }
        }
      },
      bannerPlaceHolderForWelcomeOffer (welcomeOfferData) {
        if (welcomeOfferData) {
          this.showWelcomeOfferPopup()
        }
      },
      // enableTssGlobal (newval) {
      //   if (!this.isIpCalled && newval) {
      //     this.showCurrentCountry()
      //     this.isIpCalled = true
      //   }
      // },
      bannerPlaceHolderForTssBirthday (tssBdayData) {
        if (tssBdayData) {
          this.showTssBirthdayPopup()
        }
      },
      bannerPlaceHolderForBirthdayDiscount (bdayDiscountData) {
        if (bdayDiscountData) {
          this.showBirthdayDiscountPopup()
        }
      },
      // countries () {
      //   if (this.enableTssGlobal && !this.isIpCalled) {
      //     this.showCurrentCountry()
      //     this.isIpCalled = true
      //   }
      // },
    },
    computed: {
      ...mapGetters(['authStatus', 'wishlist', '_cart', 'isExclusive', 'getViewContent', 'calculations', 'currencyRsToUSD', 'exclusiveUser', 'USER', 'genderDOBModal', 'showAppInstPopup', 'bannerPlcaeHolderData', 'user', 'username', 'isComboActive', 'webcategory', 'get_exclusive_user', 'exclusiveDetails', 'getGlobalSettingKeys', 'cartCleared', 'countries', 'showLogoutModal', 'isCodCheckoutLogin', 'ipAddresses', 'isNavBarActive']),
      ...mapState(['offerTimer', 'offerAppearTimer']),
      enableTssGlobal: function () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          const tssGlobal = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true &&
            bannerData.product_type.toLowerCase() === 'ENABLE_TSS_GLOBAL'.toLowerCase())
          if (tssGlobal) {
            return true
          } else {
            Vue.ls.remove('selectedCountryAddress')
            Vue.ls.remove('lastSelectedLocation')
            this.$store.commit('RESET_SELECTED_ADDRESS')
            if (this.authStatus) {
              // this.$store.dispatch('GET_ADDRESSES')
            }
            return false
          }
        }
      },
      showPopUp: function () {
        let showAppInstPopupFrmLs = Vue.ls.get('showAppInstPopup')
        if (this.showAppInstPopup || showAppInstPopupFrmLs) {
          return true
        }
        return false
      },
      isHomeRoute: function () {
        if (this.$route.path === '/men' || this.$route.path === '/women' || this.$route.path === '/kids' || this.$route.path === '/sneakers') {
          return true
        }
        return false
      },
      isPdpRoute: function () {
        if (this.$route.name === 'productdetails' || (this.$route.name === null && this.$route.path === '/') || this.$route.name === 'listing') {
          return true
        }
        return false
      },
      bannerPlaceHolderForMenWomenMsite: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'MENWOMEN_MSITE'.toLowerCase())
      },
      bannerPlaceHolderAppLikeSidemenuForMenWomen: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'MENWOMEN_MSITE_WITHCOMBO'.toLowerCase())
      },
      enableVincenzeSearch: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Search Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_VINCENZE_SEARCH'.toLowerCase())
      },
      routeAndIsCombo () {
        return {
          routePath: this.$route.path,
          isComboActive: this.isComboActive,
          user: this.user
        }
      },
      bannerPlaceHolderForCombos () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_COMBOS_WEB'.toLowerCase())
      },
      bannerPlaceHolderForExcPopupOnPdp () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_INI_EXC_POPUP_PDP'.toLowerCase())
      },
      bannerPlaceHolderForExcSavingTxt () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
          bannerData.product_type.toLowerCase() === 'EXCLUSIVE_SAVING_TXT_WEB'.toLowerCase())
      },
      bannerPlaceHolderForNonExcSavingTxt () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'PLP Non-Exclusive Screen'.toLowerCase() && bannerData.status === true &&
          bannerData.product_type.toLowerCase() === 'NON_EXCLUSIVE_SAVING_TXT_WEB'.toLowerCase())
      },
      bannerPlaceHolderForWishlist () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'DISABLE_WISHLIST_WEB'.toLowerCase())
      },
      bannerPlaceHolderForEmailLogin () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'DISABLE_EMAIL_LOGIN_WEB'.toLowerCase())
      },
      isSupimaLanding () {
        return this.$route && this.$route.path && this.$route.path.includes('supima-landing')
      },
      bannerPlaceHolderForWelcomeOffer () {
        const welcomeOfferObj = this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_WELCOME_OFFER_WEB'.toLowerCase())
        return welcomeOfferObj && welcomeOfferObj.tag_text && welcomeOfferObj.tag_text.split('<br/>')
      },
      isActiveWearLanding () {
        return this.$route && this.$route.path && this.$route.path.includes('active-wear-landing')
      },
      isWinterWearLanding () {
        return this.$route && this.$route.path && this.$route.path.includes('winter-wear-landing')
      },
      bannerPlaceHolderForBirthdayDiscount () {
        const birthdayDiscountObj = this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_BIRTHDAY_DISCOUNT_WEB'.toLowerCase())
        return birthdayDiscountObj && birthdayDiscountObj.tag_text && birthdayDiscountObj.tag_text.split('<br/>')
      },
      bannerPlaceHolderForTSSBirthday () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_TSS_BIRTHDAY_WEB'.toLowerCase())
      },
      bannerPlaceHolderForGoForAppOnlySale: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'GO_APP_ONLY_SALE_WEB'.toLowerCase())
      },
      notMobileOrderPage: function () {
        return !window.location.href.endsWith('/orders')
      },
      bannerPlaceHolderForClarity: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'IS_CLARITY_ENABLE_WEB'.toLowerCase())
      },
      bannerPlaceHolderForOfflineMessage: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_OFFLINE_TOAST_MESSAGE'.toLowerCase())
      },
      bannerPlaceHolderForOnlineMessage: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_ONLINE_TOAST_MESSAGE'.toLowerCase())
      },
      showCountryIsoName: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_COUNTRY_ISO_WEB'.toLowerCase())
      }
    },
    methods: {
      setRumUserContext () {
        if (window.CoralogixRum) {
          window.CoralogixRum.setUserContext({
            user_id: this.user && this.user.user_id ? this.user.user_id : 'NA',
            user_name: this.user && this.user.firstname || this.user.lastname ? `${this.user.firstname} ${this.user.lastname}` : 'NA',
            user_email: this.user && this.user.email ? this.user.email : 'NA'
          })
        }
      },
      loadThirdPartyScript (src) {
        const script = document.createElement('script')
        script.src = src
        script.async = true
        document.body.appendChild(script)
      },
      handleOffline () {
        if (this.bannerPlaceHolderForOfflineMessage) {
          this.showOfflineToast()
        }
      },
      handleOnline () {
        this.hideOfflineToast()
        new Promise((resolve) => {
          setTimeout(() => {
            resolve()
          }, 500)
        }).then(() => {
          if (this.bannerPlaceHolderForOnlineMessage) {
            Vue.toasted.show(`<i class="fa fa-wifi"></i>${this.bannerPlaceHolderForOnlineMessage && this.bannerPlaceHolderForOnlineMessage.tag_text}`, {
              theme: 'primary',
              className: 'toasted-customgreen',
              position: 'top-right',
              duration: 5000
            })
          }
        })
      },
      hideOfflineToast () {
        Vue.toasted.clear()
      },
      showOfflineToast () {
        this.hideOfflineToast()
        Vue.toasted.show(`<i class="fa fa-exclamation-triangle"></i>${this.bannerPlaceHolderForOfflineMessage && this.bannerPlaceHolderForOfflineMessage.tag_text}`, {
          theme: 'primary',
          className: 'toasted-customyellow',
          position: 'top-right',
          duration: 5000
        })
      },
      showCurrentCountry () {
        if (this.ipAddresses && this.enableTssGlobal) {
          const lastSelectedLocation = Vue.ls.get('lastSelectedLocation')
          if (lastSelectedLocation && this.showCountryIsoName) {
            let currencyData = {
              currencyType: lastSelectedLocation.selectedCountryCode || '',
              currencySymbol: lastSelectedLocation.selectedCountrySymbol === '?' ? '₹' : (lastSelectedLocation.selectedCountrySymbol || '')
            }
            this.$store.commit('SET_CURRENCY', currencyData)
          } else {
            let currencyData = {
              currencyType: this.ipAddresses.currency_code || '',
              currencySymbol: this.ipAddresses.currency_symbol || ''
            }
            this.$store.commit('SET_CURRENCY', currencyData)
          }
        } else {
          let currencyData = {
            currencyType: 'Rs.',
            currencySymbol: '₹'
          }
          this.$store.commit('SET_CURRENCY', currencyData)
        }
        this.getCurrentCountryIp = this.ipAddresses
        const currentCountryId = parseInt(this.getCurrentCountryIp.country_id)
        const selectCountryId = parseInt(this.$store.state.selectedCountryAddress.countryId)
        if (currentCountryId !== selectCountryId) {
          const lastSelectedLocation = Vue.ls.get('lastSelectedLocation')
          if (lastSelectedLocation && this.showCountryIsoName) {
            this.changeCurrentCountry(lastSelectedLocation.selectedCountryId)
          } else {
            this.changeCurrentCountry(this.getCurrentCountryIp.country_id)
          }
          // this.$store.dispatch('COUNTRY_DETAIL')
          if (this.authStatus) {
            // this.$store.dispatch('GET_ADDRESSES')
          }
          Vue.ls.set('CurrentCountryChange', 'true')
        } else {
          // this.$store.dispatch('COUNTRY_DETAIL')
          if (this.authStatus) {
            // this.$store.dispatch('GET_ADDRESSES')
          }
        }
      },
      changeCurrentCountry (countryId) {
        const filterCountry = this.countries.find(obj => obj.id === countryId)
        if (filterCountry) {
          this.selectedAddress = {
            country: filterCountry.name,
            countryId: countryId,
            isoCode: filterCountry.iso_code_3,
            isoCode2: filterCountry.iso_code_2,
            country_code: filterCountry.country_code
          }
          Vue.ls.set('selectedCountryAddress', this.selectedAddress)
          this.$store.commit('SET_SELECTED_ADDRESS', this.selectedAddress)
        }
        loadGTM()
        const configKeys = this.getGlobalSettingKeys
        if (this.$route.path !== '/maintenance') {
          Promise.all([
            this.$store.dispatch('CHECK_AUTH'),
            // this.$store.dispatch('GET_BANNERS_DATA_FROM_MOBILE_CMS'),
            this.$store.dispatch('GET_NAVMENU_DATA'),
            this.$store.dispatch('GET_UNBXD_ELASTIC_SEARCH_TYPE')
          ])
          this.$store.dispatch('GET_HOME_SCREEN_DATA', {isComboActive: this.isComboActive})
          this.$store.dispatch('GLOBAL_GET_BANNERS_DATA', { countryId, configKeys })
          // this.$store.dispatch('CART_DATA', {isReinit: 1})
          if (this.authStatus) {
            this.$store.dispatch('CART_WISHLIST_COUNT')
          }
          // this.$store.dispatch('COUNTRY_DETAIL')
          // Currently Disable for Improvement of global tss
        }
      },
      /* fucntion return Object for userAgent in devices */
      confirmLogout () {
        this.$store.dispatch('CONFIRMED_LOGOUT')
      },
      updateModalVisibility (value) {
        if (value) {
          this.$store.dispatch('OPEN_LOGOUT_MODAL')
        } else {
          this.$store.dispatch('CLOSE_LOGOUT_MODAL')
        }
      },
      checkUserAgent: function () {
        let ua = navigator.userAgent.toLowerCase()
        let isAndroid = ua.indexOf('android') > -1 // android check
        let isIphone = ua.indexOf('iphone') > -1 // ios check
        return {
          isAndroid,
          isIphone
        }
      },
      loadScript: debounce(function () {
        let snapmint = document.createElement('script')
        snapmint.type = 'text/javascript'
        snapmint.async = true
        snapmint.src = '//cdn-4.convertexperiments.com/js/10048002-10049496.js'
        let s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(snapmint, s)
      }, 5000),
      /* fucntion return deep link url */
      getDeepLinkUrl: function (url) {
        const iosLink = 'thesouledstore://www.thesouledstore.com'
        const androidLink = 'com.thesouledstore://www.thesouledstore.com'
        const webFallbackUrl = 'https://www.thesouledstore.com'
        const splittedKey = 'thesouledstore.com'
        const userAgent = this.checkUserAgent()
        let newLinkUrl = ''
        if (url.includes(splittedKey)) {
          let splitUrl = url.split(splittedKey)[1]
          if (userAgent.isIphone) {
            newLinkUrl = iosLink + splitUrl
          } else if (userAgent.isAndroid) {
            newLinkUrl = androidLink + splitUrl
          }
        } else {
          newLinkUrl = userAgent.isIphone
          ? iosLink : userAgent.isAndroid ? androidLink : webFallbackUrl
        }
        return newLinkUrl
      },
      /*
        implement javascript on web page that first first tries to open the deep link
        1. if user has app installed, then they would be redirected to open the app to specified screen
        2. if user doesn't have app installed, then their browser wouldn't recognize the URL scheme
        and app wouldn't open since it's not installed
      */
      deeplink: function () {
        let userAgent = this.checkUserAgent()
        let webUrl = 'https://www.thesouledstore.com/'
        let _this = this
        if (userAgent.isIphone === true) {
          let app = {
            launchApp: function () {
              let link = _this.getDeepLinkUrl(window.location.href)
              window.location.href = link // which page to open(now from mobile, check its authorization)
              setTimeout(() => {
                this.openWebApp
              }, 2500)
            },
            openWebApp: function () {
              window.location.href = webUrl
            }
          }
          app.launchApp()
        } else if (userAgent.isAndroid === true) {
          let app = {
            launchApp: function () {
              let link = _this.getDeepLinkUrl(window.location.href)
              window.location.href = link // which page to open(now from mobile, check its authorization)
              setTimeout(this.openWebApp, 2500)
            },
            openWebApp: function () {
              window.location.href = webUrl
            }
          }
          app.launchApp()
        } else {
          window.location.href = webUrl
          // navigate to website url
        }
      },
      getScroll () {
        var scrollPosY = window.pageYOffset | document.body.scrollTop
        var stickyOffer = document.getElementById('sticky-offer-wrapper')
        if (scrollPosY <= 30) {
          if (stickyOffer) stickyOffer.className = ('sticky-normal')
        } else if (scrollPosY > 30) {
          if (stickyOffer) stickyOffer.className = ('sticky-scrolled')
        }
      },
      startCoupon () {
        let _this = this
        if (!_this.isExclusive && !_this.cTimer.RESTRICTED_PAGES.includes(this.$route.path)) {
          if ((_this.offerTimer < _this.cTimer.OFFER_COUNTDOWN_TIMER || _this.offerAppearTimer < _this.cTimer.OFFER_APPEAR_TIMER)) {
            if (_this.offerAppearTimer < _this.cTimer.OFFER_APPEAR_TIMER && _this.offerTimer === _this.cTimer.OFFER_COUNTDOWN_TIMER) {
              _this.$store.commit('MODIFY_OFFER_APPEAR_TIMER', _this.cTimer.OFFER_APPEAR_TIMER)
              clearInterval(_this.timer1)
              clearInterval(_this.timer2)
              _this.timer1 = setInterval(function () {
                if (_this.$store.state.offerAppearTimer === 0) {
                  clearInterval(_this.timer1)
                } else {
                  if (_this.$store.state.offerAppearTimer === 1 && _this.$store.getters.calculations.total < _this.cTimer.MINIMUM_CART_VALUE) {
                    _this.$store.commit('MODIFY_OFFER_APPEAR_TIMER', _this.cTimer.OFFER_APPEAR_TIMER)
                    clearInterval(_this.timer1)
                  } else {
                    _this.$store.commit('DECREMENT_APPEAR_TIMER', 1)
                  }
                }
              }, 1000)
            }
          } else {
            clearInterval(_this.timer1)
            clearInterval(_this.timer2)
            _this.timer2 = setInterval(function () {
              if (_this.$store.state.offerAppearTimer === 0) {
                clearInterval(_this.timer2)
              } else {
                if (_this.$store.state.offerAppearTimer === 1 && _this.$store.getters.calculations.total < _this.cTimer.MINIMUM_CART_VALUE) {
                  _this.$store.commit('MODIFY_OFFER_APPEAR_TIMER', _this.cTimer.OFFER_APPEAR_TIMER)
                  clearInterval(_this.timer2)
                } else {
                  _this.$store.commit('DECREMENT_APPEAR_TIMER', 1)
                }
              }
            }, 1000)
          }
        }
      },
      renderContactUsMobile () {
        this.privacyPolicyMobile = false
        this.contactUsMobile = true
      },
      closeModal () {
        this.$store.commit('SET_GENDER_DOB_MODAL', false)
        Vue.ls.set('genderDOBModal', false)
      },
      toggleWelcomeOfferPopup (flag) {
        this.isWelcomeOfferPopup = flag
      },
      toggleBdayDiscountPopup (flag) {
        this.isBdayDiscountPopup = flag
      },
      toggleTssBdayPopup (flag) {
        this.isTssBdayPopup = flag
        Vue.ls.set('isTssBdayPopup', true)
        this.$store.commit('MOENGAGE_EVENT', {
          eventName: 'TSS_BIRTHDAY_VIEW',
          payload: {}
        })
      },
      showWelcomeOfferPopup () {
        const popUpShown = Vue.ls.get('welcomeOfferPopupShown')
        const welcomeOfferUser = Vue.ls.get('welcome_offer_user')
        if (!popUpShown &&
          this.bannerPlaceHolderForWelcomeOffer && !this.welcomeOfferTimer &&
          !(this.$route && (this.$route.path === '/login' || this.$route.path === '/register')) &&
          (!this.authStatus ||
          (this.authStatus && this.user && this.user.order_count <= 0 &&
          !(this.user.email && welcomeOfferUser && this.user.email.toLowerCase() === welcomeOfferUser.toLowerCase()))
          )
        ) {
          this.welcomeOfferTimer = setTimeout(() => {
            if (!(this.$route && (this.$route.path === '/login' || this.$route.path === '/register')) &&
              (!this.authStatus ||
              (this.authStatus && this.user && this.user.order_count <= 0 &&
              !(this.user.email && welcomeOfferUser && this.user.email.toLowerCase() === welcomeOfferUser.toLowerCase())))
            ) {
              this.isWelcomeOfferPopup = true
              Vue.ls.set('welcomeOfferPopupShown', true)
            }
          }, 5000)
        }
      },
      showBirthdayDiscountPopup () {
        if (this.user && this.user.birthdate) {
          // check if it is birthday month
          const birthdayMonth = new Date(this.user.birthdate).getMonth()
          const currentMonth = new Date().getMonth()

          // calculate popup shown time
          const bdayDiscountPopupDate = Vue.ls.get('bdayDiscountPopupDate')
          const currentTime = new Date().getTime()
          let popupShownDaysDiff
          if (bdayDiscountPopupDate) {
            popupShownDaysDiff = (currentTime - new Date(bdayDiscountPopupDate).getTime()) / (1000 * 3600 * 24)
          }

          if (birthdayMonth === currentMonth && (!bdayDiscountPopupDate || popupShownDaysDiff >= 1) &&
            this.bannerPlaceHolderForBirthdayDiscount && !this.bdayDiscountTimer &&
            !(this.$route && (this.$route.path === '/login' || this.$route.path === '/register'))
           ) {
            this.bdayDiscountTimer = setTimeout(() => {
              if (!(this.$route && (this.$route.path === '/login' || this.$route.path === '/register'))) {
                this.isBdayDiscountPopup = true
                Vue.ls.set('bdayDiscountPopupDate', new Date())
              }
            }, 10000)
          }
          if (birthdayMonth === currentMonth && this.bannerPlaceHolderForBirthdayDiscount) {
            this.$store.commit('SET_BIRTHDAY_MONTH', true)
          } else {
            this.$store.commit('SET_BIRTHDAY_MONTH', false)
          }
        }
      },
      showTssBirthdayPopup () {
        if (this.bannerPlaceHolderForTSSBirthday && this.bannerPlaceHolderForTSSBirthday.status && !Vue.ls.get('isTssBdayPopup')) {
          const startDateTime = new Date(this.bannerPlaceHolderForTSSBirthday && this.bannerPlaceHolderForTSSBirthday.start_date_time)
          const endDateTime = new Date(this.bannerPlaceHolderForTSSBirthday && this.bannerPlaceHolderForTSSBirthday.end_date_time)
          const currentDateTime = new Date()
          if (currentDateTime.getTime() >= startDateTime.getTime() && currentDateTime.getTime() <= endDateTime.getTime()) {
            this.isTssBdayPopup = true
          }
        }
      },
      customerUpdateHandler () {
        const isCustomerUpdated = Vue.ls.get('customer_update')
        if (!isCustomerUpdated) {
          this.$store.dispatch('CUSTOMER_UPDATE')
        }
      },
      getNewPdp () {
        const getUpdatedVersion = Vue.ls.get('updatedVersion')
        if (getUpdatedVersion) {
          this.updatedVersion = getUpdatedVersion
        }
        const getUdatednewDesign = Vue.ls.get('updatednewDesignMweb')
        this.axios.get(process.env.MOBILE_CMS_URL + 'product/page-design-type', {
          params: {
            updated_version: getUpdatedVersion || 0,
            design_type: getUdatednewDesign || ''
          }
        }).then((response) => {
          const responseData = response.data
          if (this.updatedVersion !== responseData.updated_version) {
            Vue.ls.set('updatedVersion', responseData.updated_version)
            Vue.ls.set('updatednewDesignMweb', responseData.design_type)
            if (responseData.design_type === 'NEW_DESIGN') {
              this.newDesignMweb = true
            }
          } else {
            const getUdatednewDesignMweb = Vue.ls.get('updatednewDesignMweb')
            if (getUdatednewDesignMweb === 'NEW_DESIGN') {
              this.newDesignMweb = true
            }
          }
        }).catch((error) => {
          console.error('An error occurred:', error)
          // Handle specific error scenarios if necessary
          // For example, show a user-friendly message or retry the request
        })
      },
      initMsClarityScript () {
        // Don't load Clarity in development mode to avoid CORS issues
        if (process.env.NODE_ENV === 'development') {
          console.log('Microsoft Clarity disabled in development mode')
          return
        }

        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.text = (function (c, l, a, r, i, t, y) {
          c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) }
          t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i
          y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y)
        })(window, document, 'clarity', 'script', 'l1mc8vm6q5')
        document.head.appendChild(script)
      }
    },
    beforeDestroy () {
      window.removeEventListener('scroll', this.getScroll)
      window.removeEventListener('offline', this.handleOffline)
      window.removeEventListener('online', this.handleOnline)
    }
  }
</script>
<style lang="css" scoped>
  .tss-body-wrapper{
    max-width: 1500px;
    margin: auto;
    min-height: 491px;
  }
  .emoji-img {
  width: 40px; /* Adjust size as needed */
  height: 50px; /* Adjust size as needed */
  margin-right: 10px;
}
.logoutContent{
  display: flex;
  align-items: center;
}
.logout-message{
  font-size: 18px;
}
  .minHeight{
    min-height: 100vh !important;
  }
  .pdpMinHeight{
    min-height: 100vh !important;
  }
  .bg-lgrey {
    background-color: #efebe9;
  }
  .activewear-grey {
    background-color: #f1f2f2;
  }
  .viewContainer {
    min-height: 450px;
    padding-bottom: 1px;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
  }

  .fade-enter-active {
    transition-delay: .25s;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }

  .slide-enter-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
  }

  .slide-leave-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  }

  .slide-enter-to, .slide-leave {
    max-height: 100px;
    overflow: hidden;
  }

  .slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
  }

  #sticky-offer-wrapper {
    height: auto;
    width: 100%;
    padding: 5px;
    background: #161615;
    z-index: 9999;
    left: 0;
  }

  .sticky-normal {
    top: 90px;
  }

  .sticky-scrolled {
    position: fixed;
    top: 61px;
  }

  @media screen and (max-width: 1200px) {
    .sticky-normal {
      top: 85px;
    }

    .sticky-scrolled {
      top: 57px;
    }
  }

  @media screen and (max-width: 991px) {

    .toastedredcolor {
      color: #ec3d25;
      background-color: #ec3d25;
      color: #fff;
      border-radius: 10px
    }

    .sticky-normal {
      top: 69px;
    }

    .sticky-scrolled {
      top: 42px;
    }
  }
  @media screen and (max-width: 767px) {
    .cat-collection-home.viewContainer {
        background: #f1f1f3!important;
    }
    .tss-body-wrapper{
      min-height: 420px;
    }
    .minHeight{
      min-height: 100vh;
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?5238bbaa